import { UID, IS_AUTH, ERROR_STATE, MENUS, LOCALE, PARAMS } from './mutation_types';

import api from '@/service';

const setUID = ({ commit }, data) => {
  commit(UID, data);
};

const setErrorState = ({ commit }, data) => {
  commit(ERROR_STATE, data);
};

const setIsAuth = ({ commit }, data) => {
  commit(IS_AUTH, data);
};

const setMenus = ({ commit }, data) => {
  commit(MENUS, data);
};

const setLocale = ({ commit }, data) => {
  commit(LOCALE, data);
};

const setParams = ({ commit }, data) => {
  commit(PARAMS, data);
}; 

const processResponse = (store, loginResponse) => {
  // http://devops.sdsdev.co.kr/confluence/pages/viewpage.action?pageId=76315514 code표 참고
  // console.log('processResponse:', loginResponse);
  switch (loginResponse.code) {
    case 'authOk':
      setUID(store, loginResponse.uid);
      setErrorState(store, { code: loginResponse.code });
      setIsAuth(store, true);
      break;
    case 'exception':
      setErrorState(store, { code: loginResponse.code, message: 'System error' });
      setIsAuth(store, false);
      break;
    default:
      // console.log(typeof loginResponse.code);
      if (typeof loginResponse.code === 'number') {
        loginResponse.code = String(loginResponse.code);
      }
      setErrorState(store, loginResponse);
      setIsAuth(store, false);
      break;
  }
};

export default {
  async login(store, { userId, password }) {
    const loginResponse = await api.login(userId, password);
    processResponse(store, loginResponse);
    return store.getters.getIsAuth;
  },
  async loginEpTray(store, { epTrayKey }) {
    const loginResponse = await api.loginEpTray(epTrayKey);
    processResponse(store, loginResponse);
    return store.getters.getIsAuth;
  },
  logout() {
    api.logout();
  },
  async getMenus(store, forceRemote = false) {
    const menuResponse = await api.getMenus(forceRemote);
    setMenus(store, menuResponse);
  },
  clearCache() {
    api.clearCache();
  },
  setLocale,
  setParams,
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js